<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="680_auto"
      :visible.sync="modalVisible"
      :loading="confirmLoading"
      @confirm="confirm">
    <template #header>广告授权</template>

    <template #content>
      <adAuthorization
          ref="adAuthorization"
          :form="form"
          :marketItem="marketItem"
          :adsSupplyCountryCode="adsSupplyCountryCode"
          @passChange="adPassChange"
      ></adAuthorization>
<!--      <div class="auth-wrapper">-->
<!--        <p class="auth-tip">1、点击【去授权】将跳转到亚马逊登录页面，<span style="color: red;">请在授权店铺主账号的常用环境操作，以免关联</span></p>-->
<!--        <p class="auth-tip">2、授权前请将后台页面切换到对应的站点</p>-->
<!--        <p class="auth-tip">3、亚马逊官方支持北美、欧洲、日本、澳洲、印度及阿联酋站</p>-->
<!--        <p class="auth-tip">4、授权成功后，系统将会：</p>-->
<!--        <ul class="auth-tip&#45;&#45;ul">-->
<!--          <li class="auth-tip&#45;&#45;li">获取您的广告数据</li>-->
<!--          <li class="auth-tip&#45;&#45;li">支持您在系统进行广告活动数据操作</li>-->
<!--          <li class="auth-tip&#45;&#45;li">亚马逊广告相关业绩数据的访问权限</li>-->
<!--        </ul>-->
<!--      </div>-->
    </template>
    <template #footer>
      <gj-button class="handle-button" @click="$emit('close'), $gjDestroy()" :loading="confirmLoading">取消</gj-button>
      <gj-button class="handle-button" type="primary" @click="confirm" :loading="confirmLoading">授权</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, responseMixin, userGuideMixin} from "../../../../../minxins";
  import {isMeaningless} from "../../../../../utils/common";
  import {adsApiAuth, getAdsAuthUrl} from "../../../../../api/system";

  import adAuthorization from "@/views/modules/system/market/components/ad-authorization";

  export default {
    name: "app-ad-authorize-modal",
    components: {
      adAuthorization
    },
    mixins: [modalMixIn, responseMixin, userGuideMixin],
    props: {
      market: {
        required: true
      },
      marketItem: {
        required: true
      },
      adsSupplyCountryCode:{
        type:Array,
        default: function (){
          return []
        }
      }
    },
    data() {
      return {
        adPass:'none',
        confirmLoading: false,
        form: {
          marketName: null,
          areaId: 'na',
          countryCodes: [],
          unionAccount: true
        },
        unionAccountOption: [
          {id: true, text: '是'},
          {id: false, text: '否'},
        ],
      }
    },
    created() {
      this.form = {
        marketName: this.market.marketName,
        areaId: this.market.region,
        unionAccount: true,
        marketIds: [],
      }
      if(this.adsSupplyCountryCode.indexOf(this.market.countryCode)>-1){
        this.form.marketIds.push(this.market.id)
      }
      window.$adAuthCallback = this.$adAuthCallback;
    },
    methods: {
      adPassChange(adPass) {
        this.adPass = adPass;
      },
      confirm() {
        if (this.adPass !== 'success') {
          this.$gjMessage.warning('验证成功后才可授权')
          return
        }
        this.confirmLoading = true;
        this.$refs.adAuthorization.saveAD(() => {
          this.confirmLoading = false;
          //刷新列表数据
          this.$emit('authed');
          // 用户引导模式的下一步
          if(this.userGuideState) {
            this.$emit('userGuide')
          }
          this.$gjDestroy()
        })
      },
      $adAuthCallback(data) {
        this.confirmLoading = true;
        this.confirmText = '授权中';
        adsApiAuth(data)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
               this.$gjMessage.success('授权成功');
               this.$emit('authed');
               this.$gjDestroy();
            });
          })
          .complete(() => {
            this.confirmLoading = false;
            this.confirmText = '授权';
          });
      }
    }
  }
</script>

<style scoped>
  .auth-wrapper {
    margin-left: 20px;
  }
  .auth-tip {
  
  }
  .auth-tip--ul {
  
  }
  .auth-tip--li {
    line-height: 20px;
  }
</style>

